import { useIntl } from 'react-intl';

import ExclamationCircleIcon from '@/assets/icons/exclamation-circle.svg';
import { Tag } from '@/components/ui/tag';
import { Tooltip } from '@/components/ui/tooltip';

/**
 * Warning nudge shown next to the hires count when an opening has more than
 * one active hiring goal. Source can only display the latest active goal, so
 * this indicator sets the right expectation until multi-goal support lands.
 *
 * TODO: Remove this component once multi-goal display support ships.
 */
export function MultipleActiveGoalsNudge() {
  const intl = useIntl();

  const tooltipContent = intl.formatMessage({
    defaultMessage:
      "Currently Source can only show one active goal at a time. We're working on supporting multiple active goals.",
    description:
      'Tooltip explaining that Source displays only the most recent active hiring goal when an opening has multiple active goals simultaneously',
  });

  const label = intl.formatMessage({
    defaultMessage: 'Only current active goal shown',
    description:
      'Warning label displayed next to the hires count when an opening has multiple active hiring goals; explains that only the most recent one is shown',
  });

  return (
    <Tooltip content={tooltipContent}>
      <span data-testid="multiple-active-goals-nudge" aria-label={label}>
        <Tag
          icon={ExclamationCircleIcon}
          text={label}
          className="bg-fx-amber-50"
          textClassName="text-fx-warning-600"
        />
      </span>
    </Tooltip>
  );
}
